import { defineComponent as I, useTemplateRef as C, computed as m, createBlock as b, openBlock as l, resolveDynamicComponent as y, withCtx as c, mergeProps as S, unref as a, createElementBlock as t, createCommentVNode as r, renderSlot as d, normalizeClass as u, createVNode as V } from "vue";
import n from "../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Button/button.js";
import L from "./Spinner.vue2.js";
import R from "../helpers/PassThrough.vue2.js";
import { useOUIAProps as T } from "../helpers/ouia.js";
import { isDefined as z } from "../node_modules/.pnpm/@vueuse_shared@13.1.0_vue@3.5.13_typescript@5.8.3_/node_modules/@vueuse/shared/index.js";
const q = /* @__PURE__ */ I({
  name: "PfButton",
  inheritAttrs: !1,
  __name: "Button",
  props: {
    component: { default: "auto" },
    block: { type: Boolean },
    disabled: { type: Boolean },
    ariaDisabled: { type: Boolean },
    loading: { type: Boolean, default: void 0 },
    spinnerAriaValueText: {},
    spinnerAriaLabel: {},
    spinnerAriaLabelledBy: {},
    inoperableEvents: {},
    inline: { type: Boolean },
    type: { default: "button" },
    variant: { default: "primary" },
    state: {},
    noPadding: { type: Boolean },
    iconPosition: { default: "start" },
    tabindex: {},
    small: { type: Boolean },
    large: { type: Boolean },
    danger: { type: Boolean },
    badgeClass: {},
    to: {},
    replace: { type: Boolean },
    href: {},
    ariaCurrent: {},
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  emits: ["click"],
  setup(v, { expose: g, emit: k }) {
    const o = v, B = k, P = C("elRef"), $ = T({ id: o.ouiaId, safe: o.ouiaSafe, variant: o.variant }), s = m(() => o.component !== "auto" ? o.component : o.href || o.to ? "a" : "button"), f = m(() => o.loading || o.disabled || null), h = m(() => o.tabindex ? o.tabindex : o.disabled ? o.component === "button" ? null : -1 : !o.ariaDisabled && o.component === "span" ? 0 : null);
    function D(e, p) {
      if (f.value) {
        e.preventDefault();
        return;
      }
      if (p) {
        p(e);
        return;
      }
      B("click", e);
    }
    return g({
      el: P
    }), (e, p) => (l(), b(y(e.to ? "router-link" : R), {
      to: e.to,
      replace: e.replace,
      custom: ""
    }, {
      default: c((i) => [
        (l(), b(y(s.value), S({ ...a($), ...e.$attrs }, {
          ref: "elRef",
          type: s.value === "button" ? e.type : null,
          disabled: f.value,
          "aria-disabled": f.value || e.ariaDisabled,
          class: [a(n).button, a(n).modifiers[e.variant], {
            [a(n).modifiers.block]: e.block,
            [a(n).modifiers.disabled]: e.disabled,
            [a(n).modifiers.ariaDisabled]: e.ariaDisabled,
            [a(n).modifiers.inline]: e.inline && e.variant === "link",
            [a(n).modifiers.danger]: e.danger && (e.variant === "link" || e.variant === "secondary"),
            [a(n).modifiers.noPadding]: e.noPadding && e.variant === "plain",
            [a(n).modifiers.small]: e.small,
            [a(n).modifiers.displayLg]: e.large,
            [a(n).modifiers.progress]: a(z)(e.loading),
            [a(n).modifiers.inProgress]: e.loading,
            [a(n).modifiers[e.state]]: e.state && e.variant === "stateful"
          }],
          tabindex: h.value,
          role: s.value !== "button" ? "button" : null,
          href: e.href || (s.value === "a" ? i == null ? void 0 : i.href : null),
          onClick: (A) => D(A, i == null ? void 0 : i.navigate)
        }), {
          default: c(() => [
            e.loading ? (l(), t("span", {
              key: 0,
              class: u(a(n).buttonProgress)
            }, [
              V(L, {
                size: "md",
                "aria-valuetext": e.spinnerAriaValueText
              }, null, 8, ["aria-valuetext"])
            ], 2)) : r("", !0),
            e.$slots.icon && e.iconPosition === "start" ? (l(), t("span", {
              key: 1,
              class: u([a(n).buttonIcon, a(n).modifiers.start])
            }, [
              d(e.$slots, "icon")
            ], 2)) : r("", !0),
            d(e.$slots, "default"),
            e.$slots.icon && e.iconPosition === "end" ? (l(), t("span", {
              key: 2,
              class: u([a(n).buttonIcon, a(n).modifiers.end])
            }, [
              d(e.$slots, "icon")
            ], 2)) : r("", !0),
            e.$slots.badge ? (l(), t("span", {
              key: 3,
              class: u([a(n).buttonCount, e.badgeClass])
            }, [
              d(e.$slots, "badge")
            ], 2)) : r("", !0)
          ]),
          _: 2
        }, 1040, ["type", "disabled", "aria-disabled", "class", "tabindex", "role", "href", "onClick"]))
      ]),
      _: 3
    }, 8, ["to", "replace"]));
  }
});
export {
  q as default
};
